export default "__VITE_ASSET__DtuIBB$6__";